import { ExternalQuestion } from '@sm/question-widgets/respondent-survey';

type RandomAssignmentImplicit = {
  randomAssignmentVariableId: string;
};

/**
 *
 * @param questionId  string representing question_id of the answered question.
 * @param mappedQuestions memoized list of SurveyQuestions of type ExternalQuestion[]
 * @returns an array of type RandomAssignmentImplicit containing the variable_id of the chosen question text when question text A/B is enabled
 */

export const mapImplicitResponse = (
  questionId: string,
  mappedQuestions: ExternalQuestion[]
): RandomAssignmentImplicit[] => {
  // get the current question for the answer by matching questionId from answer
  const currentQuestion = mappedQuestions.find(q => q.id === questionId);
  const assignments = currentQuestion?.heading.assignments;

  if (!currentQuestion || !assignments || assignments.length === 0) {
    return [];
  }

  const randomAssignmentVariableId =
    assignments.find(({ heading: { text } }) => text === currentQuestion.heading.default.text)?.id ?? '';
  return [{ randomAssignmentVariableId }];
};

export default mapImplicitResponse;
